/**
 * Хелперы multi-select объектов на карте (Wave 1.3).
 */

/** Уникальные id, порядок стабильный (сортировка по возрастанию). */
export function normalizeObjectIdList(ids: Iterable<number>): number[] {
  const out = new Set<number>();
  for (const id of ids) {
    if (Number.isFinite(id) && id > 0) out.add(Math.trunc(id));
  }
  return Array.from(out).sort((a, b) => a - b);
}

export function toggleIdInList(ids: number[], id: number): number[] {
  const set = new Set(ids);
  if (set.has(id)) set.delete(id);
  else set.add(id);
  return normalizeObjectIdList(set);
}

export function mergeIdsIntoList(ids: number[], add: Iterable<number>): number[] {
  return normalizeObjectIdList([...ids, ...add]);
}

/** MapLibre filter: object_id ∈ ids (пусто → ничего не подсвечивать). */
export function mvtObjectIdInFilter(ids: number[]): unknown[] {
  if (ids.length === 0) {
    return ["==", ["to-number", ["get", "object_id"]], -1];
  }
  return ["in", ["to-number", ["get", "object_id"]], ["literal", ids]];
}
